import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionQuotationPage_QuotationInfo_Update_Mutation = graphql(`
  mutation MissionQuotationPage_QuotationInfo_Update(
    $missionId: Id!
    $update: QuotationInfoInput!
    $versionData: VersionDataInput
  ) {
    updateQuotationInfo(
      missionId: $missionId
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type UpdateInput = VariablesOf<
  typeof MissionQuotationPage_QuotationInfo_Update_Mutation
>['update'];

export type QuotationInfo_Update_Result = ResultOf<
  typeof MissionQuotationPage_QuotationInfo_Update_Mutation
>;

export const useUpdateQuotationInfoMutation = () =>
  useGraphQLMutation(MissionQuotationPage_QuotationInfo_Update_Mutation);
